import React from 'react';
import { RocketImage, TickIcon } from 'src/assets/images';
import './rocket-animation.scss';

export default function RocketAnimation(isRefunds = false) {
  return (
    <div className="rocket-animation">
      <div className={!isRefunds ? 'move-up-animation' : 'move-up-animation-refunds'}>
        <div className="has-text-centered">
          <div className="rocket">
            <img src={RocketImage} />
          </div>
          <div className="icon-container">
            <div className={'tick-icon fade-in-icon'}>
              <img src={TickIcon} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
